import type { Notification } from "../../types/communications/NotificationTypes";

export const isQueueAlert = (n: Notification | null | undefined): boolean =>
	typeof n?.category === "string" && n.category.startsWith("messaging.queue_");
